import React, { useState, useRef, useCallback, useEffect } from "react";
import {
  Card,
  Button,
  Breadcrumb,
  SearchItem,
} from "../../../../../common";
import { ReactComponent as Spinner } from "../../../../../../assets/icons/spinner.svg";
import { EmptySearch } from ".././EmptySearch";
import { ReactComponent as GPS } from "../../../../../../assets/icons/GPS.svg";
import { ReactComponent as Magnifier } from "../../../../../../assets/icons/Magnifier.svg";
import { Countries } from "../../../../../public/Home/CountryFlag";
import { ReactComponent as ArrowLeft } from "../../../../../../assets/icons/arrowleft.svg";
import { ReactComponent as Warning } from "../../../../../../assets/icons/Warning.svg";
import useSearchCompany from "../../../../../../Hooks/useSearchCompany";
import { useSelector, useDispatch } from "react-redux";
import useCountryCode from "../../../../../../Hooks/useCountryCode";
import { setCountryData } from "../../../../../../store/search/searchSlice";

export const SearchCompanyStatement = ({ getSelectedCompanyFromSearch, companyCreatingLoading, handleSearchState }) => {
  const dispatch = useDispatch();
  const { countryCode } = useCountryCode();
  const [searchValue, setSearchValue] = useState("");
  const [activeItem, setActiveItem] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [displayUl, setDisplayUl] = useState(false);
  const [results, setResults] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState();
  const [loading, setLoading] = useState(false);
  const [country, setCountry] = useState({
    name: "Select Country",
    flag: null,
    code: null,
  });

  const {
    worldBoxToken,
  } = useSelector((state) => state.search);

  const handleCountrySelect = (countryCode) => {
    const countryData = Countries.find(country => country.code === countryCode);
    const countryDetail = {
      name: countryData.name,
      flag: countryData.file_url,
      code: countryData.code,
    };
    dispatch(setCountryData(countryDetail));
    setCountry(countryDetail)
  }

  // useEffect(() => {
  //   if (countryCode && country.code !== countryCode) {
  //     handleCountrySelect(countryCode)
  //   }
  // }, [])

  const { token, userInfo } = useSelector((state) => state.auth);

  const { data, isLoading, message } = useSearchCompany(
    searchValue,
    country?.code,
    token,
    worldBoxToken
  );

  useEffect(() => {
    if (data && searchValue && searchValue.length >= 3) {
      setResults(data)
      setLoading(false);
    }
  })

  const dropdownRef = useRef(null);

  const getSelectedCompany = (company) => {
    setSelectedCompany(company);
  };

  const handleClick = (company, index) => {
    setActiveItem(index);
    getSelectedCompany(company);
  };
  const handleSelect = () => {
    getSelectedCompanyFromSearch(selectedCompany);
  }

  const handleSearch = (e) => {
    e.preventDefault();

    if (country.code === null) {
      setDisplayUl(true);
      return;
    }
    setSearchValue(e.target.value);
    setLoading(isLoading);
    if (e.target.value.trim() === '' || e.target.value.length < 3) {
      setResults([]);
      setLoading(false);
      return;
    }


  };


  const handleCountry = (option) => {
    const countryDetail = {
      name: option.name,
      flag: option.file_url,
      code: option.code,
    };
    setCountry(countryDetail);
    setDisplayUl(false);
  };

  const handleDisplayUl = (e) => {
    e.preventDefault();
    setDisplayUl(true);
  };

  //search filter
  const handleFilteredData = (event) => {
    const searchLetters = event.target.value;
    setSearchTerm(searchLetters);

    const filteredData = Countries.filter((item) => item.name.toLowerCase().includes(searchTerm.toLowerCase()));
    setFilteredData(filteredData);
  };

  //handle location popup
  const handleLocationPopup = async (e) => {
    e.preventDefault();
    try {
      handleCountrySelect(countryCode)
    } catch (error) {
    }
    setDisplayUl(false);
  };

  const handleEvent = () => {
    handleSearchState("search")
  }

  const isSafeImageUrl = (url) => {
    try {
      const parsed = new URL(url);
      return ["https:", "http:"].includes(parsed.protocol);
    } catch {
      return false;
    }
  };


  return (
    <Card classes="rounded bg-white p-4 w-[34rem] text-left">
      <div>
        <label for="search-dropdown" className="block mb-1 text-sm text-secondarytwo font-semibold text-left">
          Select Country
        </label>

        <div className="flex my-2 mb-6" ref={dropdownRef}>
          <div
            className="w-full justify-between cursor-pointer truncate flex-shrink-0 z-10 inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200 focus:ring-gray-300 "
            onClick={handleDisplayUl}>
            <div className="cursor-pointer flex text-left text-xs overflow-hidden" role="presentation">
              {country?.flag && <img src={country.flag} width="20px" height="20px" className="mr-2 h-5" alt="hello" />}
              {country?.name}
            </div>
            <ArrowLeft className={displayUl ? "rotate-90" : "-rotate-90"} />
          </div>
          <div className={`${displayUl ? "" : "hidden"} shadow-boxPopup rounded-md mt-12 w-96 bg-white p-5 sm:max-h-84 sm:min-h-fit absolute z-10`}>
            <div className="text-link border-b border-slate p-3 mb-3 font-semibold cursor-pointer items-center flex" onClick={handleLocationPopup}>
              <GPS className="mr-3" /> Detect using GPS
            </div>
            <div className="flex items-center">
              <Magnifier className="absolute mb-3 mx-3" />

              <input type="text" className="border-input border w-full p-2 px-11 mb-3 shadow-search rounded" onKeyUp={handleFilteredData} />
            </div>
            <ul className="overflow-y-auto shadow-boxPopup border-greyFade border sm:max-h-64 sm:min-h-fit rounded-md">
              {filteredData.map((option) => (
                <li
                  onClick={() => handleCountry(option)}
                  className="px-4 py-3 cursor-pointer hover:bg-input flex text-left text-xs"
                  role="presentation">
                  <img
                    src={isSafeImageUrl(option.file_url)}
                    width="20"
                    height="20"
                    className="mr-2 h-5"
                    alt={`${option.name} flag`}
                    loading="lazy"
                  />                  {option.name}
                </li>
              ))}
            </ul>
          </div>
        </div>


      </div>

      <div>
        <label
          htmlFor="search-dropdown"
          className="block mb-1 text-sm text-secondarytwo font-semibold text-left"
        >
          Search Business
        </label>
        <div className="flex mt-2 mb-2">
          <div className="relative w-full">
            <input
              type="search"
              id="search-dropdown"
              className="block p-2.5 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 "
              placeholder="Search"
              value={searchValue}
              required
              onChange={handleSearch}
            />
            {message !== "" && <div className="bg-warning border-warning border rounded-lg p-1 my-2 text-left text-warning flex gap-3 items-center text-f10">
              <Warning />
              <span>
                {message === 'error' ? <span>Technical issues may affect results. Please try again later.</span> : " " + message}
              </span>
            </div>}
            {loading && (
              <div className="absolute right-2 top-3 bg-white">
                <Spinner />
              </div>
            )}
          </div>
        </div>
        {results?.length === 0 && (
          <EmptySearch
            searchLabel={"Search here"}
            searchEmptyText='No results found'
          />
        )}
        {results?.length > 0 && (
          <div className="p-2 border-slate border rounded max-h-56 overflow-y-auto">
            {results.map((company, index) => (
              <SearchItem
                key={index}
                company={company}
                index={index}
                getSelectedCompany={handleClick}
                activeItem={activeItem}
              />
            ))}
          </div>
        )}
        <span className="py-4 text-f14 text-secondary font-semibold flex gap-1">
          Business not found?
          <Button classes="text-primaryText" onClick={handleEvent}>
            Click here
          </Button>
        </span>
        <Button
          onClick={handleSelect}
          classes="w-full p-2 bg-primary text-white rounded text-f18 mt-4 align-center"
        >
          {companyCreatingLoading ? <Spinner /> : "Select"}
        </Button>
      </div>
    </Card>
  );
};


